import PropTypes from 'prop-types'
import {useEffect} from 'react'
import {useParams} from 'react-router-dom'
import TextareaWiz from '../../../../../../../common/inputs/wizard/TextareaWiz.jsx'
import {JsonViewer} from '../../../../../../../common/JsonViewer.jsx'
import {HeaderTitle} from '../../../../../../../common/HeaderTitle.jsx'
import InputNumericWiz from "../../../../../../../common/inputs/wizard/InputNumericWiz.jsx";
import InputWiz from "../../../../../../../common/inputs/wizard/InputWiz.jsx";
import DateTimeWiz from "../../../../../../../common/inputs/wizard/DateTimeWiz.jsx";
import {Col, Row} from "react-bootstrap";
import {usePlanHarmData} from '../../../../../../../../api/domain/elementyRejstru/queries/usePlanHarmData.jsx'

export const DanePodstawowe = (props) => {
    const { id: rejestrId } = useParams();
    const kategoria = props.wiz?.form?.kategoria || '';
    const isKatA = kategoria === 'A';

    const { data: planHarmData } = usePlanHarmData(rejestrId, null, !!rejestrId && isKatA);

    useEffect(() => {
        if (!props.wiz || !isKatA || !planHarmData) return;

        const budzetSum = (parseFloat(planHarmData.inicjacja_budzet_planowany) || 0)
            + (parseFloat(planHarmData.przygotowania_budzet_planowany) || 0)
            + (parseFloat(planHarmData.realizacja_budzet_planowany) || 0)
            + (parseFloat(planHarmData.zamykania_budzet_planowany) || 0);

        const newValues = {
            data_rozpoczecia: planHarmData.inicjacja_data_rozpoczecia || '',
            data_zakonczenia: planHarmData.zamykania_data_zakonczenia || '',
            wartosc_calkowita: budzetSum,
        };

        const current = props.wiz.form || {};
        const needsUpdate = Object.entries(newValues).some(
            ([k, v]) => String(current[k] ?? '') !== String(v)
        );

        if (needsUpdate) {
            props.wiz.setWizForm({ ...current, ...newValues });
        }
    }, [isKatA, planHarmData, props.wiz]);

    return (
        <div>
            <JsonViewer src={props.wiz?.form || {}} show={false}/>

            <HeaderTitle noHr size={'fs-3'} title={'Dane podstawowe'}/>
            <HeaderTitle
                noHr
                size={'fs-4'}
                title={'Wprowadź podstawowe dane dotyczące projektu'}
            />

            <div className={'d-flex flex-column gap-3'}>
                <TextareaWiz md={4} wiz={props.wiz} keyName={'tytul'}/>

                <Row>
                    <Col>
                        {isKatA ? (
                            <InputWiz
                                wiz={props.wiz}
                                keyName={'data_rozpoczecia'}
                                disabled={true}
                            />
                        ) : (
                            <>
                                <DateTimeWiz
                                    hideTime
                                    wiz={props.wiz}
                                    keyName={'data_rozpoczecia'}
                                    label={props.wiz?.getLabel?.('data_rozpoczecia') || 'B.1 Data rozpoczęcia projektu'}
                                />
                            </>
                        )}
                    </Col>
                    <Col>
                        {isKatA ? (
                            <InputWiz
                                wiz={props.wiz}
                                keyName={'data_zakonczenia'}
                                disabled={true}
                            />
                        ) : (
                            <>
                                <DateTimeWiz
                                    hideTime
                                    wiz={props.wiz}
                                    keyName={'data_zakonczenia'}
                                    label={props.wiz?.getLabel?.('data_zakonczenia') || 'B.2 Data zakończenia projektu'}
                                />
                            </>
                        )}
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <InputNumericWiz
                            wiz={props.wiz}
                            keyName={'wartosc_calkowita'}
                            decimal={2}
                            max={99999999999999.99}
                            disabled={isKatA}
                        />
                    </Col>
                </Row>

                <label className={"d-flex fw-bold mb-0 w-100 "}>D. Kierownik Projektu</label>
                <Row>
                    <Col xs={12} md={4}>
                        <InputWiz wiz={props.wiz} keyName={'kierownik_imie'}/>
                    </Col>
                    <Col xs={12} md={4}>
                        <InputWiz wiz={props.wiz} keyName={'kierownik_nazwisko'}/>
                    </Col>
                    <Col xs={12} md={4}>
                        <InputWiz wiz={props.wiz} keyName={'kierownik_stanowisko'}/>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6}>
                        <InputWiz wiz={props.wiz} keyName={'kierownik_telefon'}/>
                    </Col>
                    <Col xs={12} md={6}>
                        <InputWiz wiz={props.wiz} keyName={'kierownik_email'}/>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

DanePodstawowe.propTypes = {
    wiz: PropTypes.any,
}
